import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faSignOut } from '@fortawesome/pro-regular-svg-icons/faSignOut';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faTruck } from '@fortawesome/pro-regular-svg-icons/faTruck';
import { faBox } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faTasks } from '@fortawesome/pro-regular-svg-icons/faTasks';
import { faBullseyePointer } from '@fortawesome/pro-regular-svg-icons/faBullseyePointer';
import { faConveyorBelt } from '@fortawesome/pro-regular-svg-icons/faConveyorBelt';
import { faAddressCard } from '@fortawesome/pro-regular-svg-icons/faAddressCard';
import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter';

import { faImage as falImage } from '@fortawesome/pro-light-svg-icons/faImage';
import { faSpiderWeb as falSpiderWeb } from '@fortawesome/pro-light-svg-icons/faSpiderWeb';

import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

// Regular
library.add(
  faSignOut,
  faSearch,
  faTruck,
  faBox,
  faTasks,
  faBullseyePointer,
  faConveyorBelt,
  faAddressCard,
  faFilter,
);

// Light
library.add(
  falImage,
  falSpiderWeb,
);

// Solid
library.add(
  fasTimes,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
